'use client';

import { Oura as OuraLogo } from '@jouzen/ecom-components/icons/Oura';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { cx } from 'class-variance-authority';

import { useCobranded } from '@/app/contexts/CobrandedProvider';

import { Svg } from '../../ui';
import { logo as logoStyles } from './styles';

const GlobalHeader = () => {
  const { config } = useCobranded();

  const styles = {
    logo: logoStyles({ logo: config?.logo }),
  };

  return (
    <LayoutGrid className="bg-white" data-testid="global-header">
      <GridItem
        className="flex h-14 items-center lg:h-20"
        colEnd={{ sm: 'main' }}
        colStart={{ sm: 'main' }}
      >
        <span className="flex h-8 items-center gap-4 lg:h-12">
          {config?.logo && (
            <>
              {/* partner logo */}
              <span className={styles.logo}>
                <Svg name={config.logo} />
              </span>

              {/* separator */}
              <span
                className="my-4 h-5 border-l border-solid border-gray-600 lg:h-6"
                aria-hidden="true"
              />
            </>
          )}

          <span className={cx('w-16 lg:w-20')}>
            <OuraLogo data-cy="oura-logo" />
          </span>
        </span>
      </GridItem>
    </LayoutGrid>
  );
};

export default GlobalHeader;
